import { defineAction } from '~/prix'
import { z } from 'zod'
import materialInventoryUpdateAction from './materialInventoryUpdate.action.json' with { type: 'json' }
import { materialInventoryObject } from '../materialInventoryObject'

const materialInventoryUpdateDefinition = defineAction({
  ...materialInventoryUpdateAction,
  input: materialInventoryObject
    .pick({
      id: true,
      materialId: true,
      quantity: true,
      type: true,
    })
    .partial()
    .required({ id: true }),
  output: z.object({}),
})

export default materialInventoryUpdateDefinition
